import React, { useState } from 'react';
import { logger } from '../utils/logger';

function DaikinOICD({ sessionToken, saveCredentials }) {
  const [clientId, setClientId] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [saveStatus, setSaveStatus] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleOICDLogin = async () => {
    // Check if both client_id and api_key are provided
    if (!clientId.trim() || !apiKey.trim()) {
      alert('Please enter both Client ID and API Key before authenticating');
      return;
    }

    logger.log('Starting Daikin OIDC Authentication');
    setIsSaving(true);
    setSaveStatus('Saving credentials...');

    // First, save the credentials
    const result = await saveCredentials('daikin_credentials', {
      client_id: clientId,
      api_key: apiKey
    });

    if (!result.success) {
      setSaveStatus('Error saving credentials');
      setIsSaving(false);
      setTimeout(() => setSaveStatus(''), 3000);
      return;
    }

    logger.log('Daikin credentials saved, redirecting to OIDC...');
    setSaveStatus('Redirecting to authentication...');

    // Then redirect to OIDC flow
    const redirectUri = `https://dashboard.habitaio.com/callback`;
    logger.log("REDIRECT URI:", redirectUri);
    const responseType = 'code';
    const state = `dk_${sessionToken}`;
    const authUrl = `https://idp.onecta.daikineurope.com/v1/oidc/authorize?client_id=${encodeURIComponent(clientId)}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&scope=openid%20onecta:basic.integration&state=${state}`;

    logger.log("Auth URL:", authUrl);

    // Small delay to show the status message before redirect
    setTimeout(() => {
      window.location.href = authUrl;
    }, 500);
  };


  
  return (
    <div className="provider-card">
      <h3 className="provider-title">Daikin</h3>
      <div className="input-group">
        <label htmlFor="daikin-client-id" className="input-label">
          Client ID
        </label>
        <input
          id="daikin-client-id"
          type="text"
          className="input-field"
          value={clientId}
          onChange={(e) => setClientId(e.target.value)}
          placeholder="Enter your Daikin Client ID"
        />
      </div>
      <div className="input-group">
        <label htmlFor="daikin-api-key" className="input-label">
          API Key
        </label>
        <input
          id="daikin-api-key"
          type="text"
          className="input-field"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          placeholder="Enter your Daikin API Key"
        />
      </div>
      <button
        onClick={handleOICDLogin}
        className="auth-button"
        disabled={!sessionToken || isSaving}
      >
        {isSaving ? 'Saving...' : 'Authenticate'}
      </button>
      {saveStatus && (
        <div className={`save-status ${saveStatus.includes('Error') ? 'error' : 'success'}`}>
          {saveStatus}
        </div>
      )}
    </div>
  );
}

export default DaikinOICD;